import { api } from "../../api";

const adminApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getSuperAdminDashboardSummary: builder.query({
      query: () => ({
        url: "/admin/dashboard/summary",
        method: "GET",
      }),
      providesTags: [{ type: "AdminDashboard", id: "SUMMARY" }],
    }),
    getAdminCustomer: builder.query({
      query: ({ id }) => ({
        url: `/admin/customers/${id}`,
        method: "GET",
      }),
      providesTags: (_result, _error, { id }) => [
        { type: "Customers", id },
      ],
    }),
    updateAdminCustomer: builder.mutation({
      query: ({ id, data }) => ({
        url: `/admin/customers/${id}`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: (_result, _error, { id }) => [
        { type: "Customers", id },
        { type: "Customers", id: "LIST" },
        { type: "AdminDashboard", id: "SUMMARY" },
      ],
    }),
    getAdminCustomerBillingSummary: builder.query({
      query: ({ id, limit = 10 } = {}) => ({
        url: `/admin/customers/${id}/billing/summary?limit=${limit}`,
        method: "GET",
      }),
      providesTags: (_result, _error, { id }) => [
        { type: "Customers", id },
      ],
    }),
    createAdminCustomerCheckoutSession: builder.mutation({
      query: ({ id, ...body }) => ({
        url: `/admin/customers/${id}/billing/checkout-session`,
        method: "POST",
        body,
      }),
    }),
    createAdminCustomerBillingPortalSession: builder.mutation({
      query: ({ id, ...body }) => ({
        url: `/admin/customers/${id}/billing/portal`,
        method: "POST",
        body,
      }),
    }),
    createAdminCustomerBillingInvoice: builder.mutation({
      query: ({ id, ...body }) => ({
        url: `/admin/customers/${id}/billing/invoices`,
        method: "POST",
        body,
      }),
      invalidatesTags: (_result, _error, { id }) => [{ type: "Customers", id }],
    }),
    updateAdminCustomerBillingInvoice: builder.mutation({
      query: ({ id, invoiceId, ...body }) => ({
        url: `/admin/customers/${id}/billing/invoices/${invoiceId}`,
        method: "PATCH",
        body,
      }),
      invalidatesTags: (_result, _error, { id }) => [{ type: "Customers", id }],
    }),
    importAdminCustomerCsv: builder.mutation({
      query: ({ id, ...body }) => ({
        url: `/admin/customers/${id}/import/csv`,
        method: "POST",
        body,
      }),
      invalidatesTags: (_result, _error, { id }) => [
        { type: "Customers", id },
        { type: "Customers", id: "LIST" },
        { type: "Clients", id: "LIST" },
        { type: "Locations", id: "LIST" },
        { type: "Jobs", id: "LIST" },
        { type: "Employees", id: "LIST" },
        { type: "Drivers", id: "LIST" },
      ],
    }),
    getAuditLogs: builder.query({
      query: ({ tenantId, limit = 100, skip = 0 } = {}) => {
        const params = new URLSearchParams();
        params.set("limit", String(limit));
        params.set("skip", String(skip));
        if (tenantId) {
          params.set("tenantId", tenantId);
        }
        return {
          url: `/admin/audit-logs?${params.toString()}`,
          method: "GET",
        };
      },
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetSuperAdminDashboardSummaryQuery,
  useGetAdminCustomerQuery,
  useUpdateAdminCustomerMutation,
  useGetAdminCustomerBillingSummaryQuery,
  useCreateAdminCustomerCheckoutSessionMutation,
  useCreateAdminCustomerBillingPortalSessionMutation,
  useCreateAdminCustomerBillingInvoiceMutation,
  useUpdateAdminCustomerBillingInvoiceMutation,
  useImportAdminCustomerCsvMutation,
  useGetAuditLogsQuery,
} = adminApi;
